import { ValidatorFn, Validators } from '@angular/forms';
import { GrocyConsumeProduct } from '../../../../core/entities/grocy/product-actions/product-action.entity';
import { GrocyQuantityUnitBasics } from '../../../../core/entities/grocy/quantity-units/quantity-unit-basics.entity';
import { GrocyStockEntry } from '../../../../core/entities/grocy/stock-entries/stock-entry.entity';
import { positive } from '../../../../forms/form-control-options.constants';
import { GrocyDashboardQuickActionConsumeFormControls } from '../form-controls/dashboard-quick-action.form-controls';
import { GrocyDashboardQuickActionForm } from './dashboard-quick-action.form';

export class GrocyDashboardQuickActionConsumeForm extends GrocyDashboardQuickActionForm<GrocyDashboardQuickActionConsumeFormControls> {
  formGroup = this.createFormGroup(GrocyDashboardQuickActionConsumeFormControls);

  public get amountHint(): string | undefined {
    const currentStock = this.selectedProduct?.stockAmount || 0;
    const newAmount = currentStock - this.amount;
    return `${currentStock} → ${newAmount} ${this.quantityUnit?.namePlural}`;
  }

  public get productAction(): GrocyConsumeProduct {
    const productAction: GrocyConsumeProduct = {
      amount: this.amount,
      productId: this.selectedProduct!.id,
      spoiled: this.controls.spoiled.value!,
    };

    if (this.controls.stockEntry.value) {
      productAction.stockEntryId = this.controls.stockEntry.value.stockId;
    }

    return productAction;
  }

  public get quantityUnit(): GrocyQuantityUnitBasics | undefined {
    return this.selectedProduct?.quantityUnits.stock;
  }

  public override canSelectStockEntry(stockEntry: GrocyStockEntry): boolean {
    return stockEntry.amount > 0;
  }

  public setAmountToMax(): void {
    if (this.selectedProduct) {
      if (this.controls.stockEntry.value) {
        this.controls.amount.setValue(this.controls.stockEntry.value.amount);
      } else {
        this.controls.amount.setValue(this.selectedProduct.stockAmount);
      }
    }
  }

  protected setChangeListeners(): void {
    this.controls.stockEntry.valueChanges.subscribe(stockEntry => {
      let maxAmount = this.selectedProduct?.stockAmount || 0;

      if (stockEntry) {
        maxAmount = stockEntry.amount;
      }

      this.controls.amount.setValidators([Validators.required, Validators.min(0.000001), Validators.max(maxAmount)]);
      this.controls.amount.setValue(this.selectedProduct?.defaultAmount || 1);

      this.controls.amount.updateValueAndValidity();
    });
  }

  protected setInitialValues(): void {
    this.controls.amount.setValidators([
      ...(positive.validators as ValidatorFn[]),
      Validators.max(this.selectedProduct?.stockAmount || 0),
    ]);
  }
}
